import React, { useEffect } from "react";
import ReactModal from "react-modal";

import logger from "../../utils/LoggerFrontend";

import * as Styled from "./Modal.styled";
import { IconClose } from "../Icons";

const Modal = ({ children, headline, isOpen, onClose }) => {
  useEffect(() => logger.log("Modal", "called..."), []);

  function handleClose() {
    onClose();
  }

  return (
    <ReactModal
      closeTimeoutMS={200}
      contentLabel="Modal"
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={true}
      shouldFocusAfterRender={false}
      style={Styled.customStyle}
      ariaHideApp={false}
    >
      <Styled.Header>
        <h2>{headline}</h2>
        <Styled.ButtonIcon onClick={handleClose}>
          <IconClose />
        </Styled.ButtonIcon>
      </Styled.Header>

      <Styled.Content>{children}</Styled.Content>
    </ReactModal>
  );
};

export default Modal;
